module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-3-fbf08f13151496f5749a76d4a03707bd.webp";